import { render, staticRenderFns } from "./SecretAchievementRow.vue?vue&type=template&id=a2a0e480"
import script from "./SecretAchievementRow.vue?vue&type=script&lang=js"
export * from "./SecretAchievementRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports